// extracted by mini-css-extract-plugin
module.exports = {"title":"SectionRentSpace_title__1b651","memberships":"SectionRentSpace_memberships__29Ljc","serviceTitleSectionClass":"SectionRentSpace_serviceTitleSectionClass__2EaP0"};